// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

// ========================================
// Filter List - View More/Less Functionality (10 at a time)
// ========================================
(function() {
  const ITEMS_PER_PAGE = 10;

  function initFilterViewMore() {
    const viewMoreButtons = document.querySelectorAll('[data-filter-view-more]');
    
    viewMoreButtons.forEach(function(button) {
      // Skip if already initialized
      if (button.hasAttribute('data-initialized')) return;
      button.setAttribute('data-initialized', 'true');
      
      const filterList = button.previousElementSibling;
      const allItems = filterList.querySelectorAll('li');
      const totalItems = allItems.length;
      
      // Initialize: show first 10, hide rest
      let visibleCount = ITEMS_PER_PAGE;
      updateVisibility(allItems, visibleCount);
      updateButtonText(button, totalItems, visibleCount);
      
      button.addEventListener('click', function() {
        // Show 10 more items
        visibleCount = Math.min(visibleCount + ITEMS_PER_PAGE, totalItems);
        updateVisibility(allItems, visibleCount);
        updateButtonText(button, totalItems, visibleCount);
        
        // Hide button if all items are visible
        if (visibleCount >= totalItems) {
          button.style.display = 'none';
        }
      });
    });
  }

  function updateVisibility(items, visibleCount) {
    items.forEach(function(item, index) {
      if (index < visibleCount) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
  }

  function updateButtonText(button, totalItems, visibleCount) {
    const remaining = totalItems - visibleCount;
    const viewMoreText = button.querySelector('[data-view-more-text]');
    if (viewMoreText && remaining > 0) {
      const showNext = Math.min(remaining, ITEMS_PER_PAGE);
      viewMoreText.textContent = 'View More (' + remaining + ')';
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterViewMore);
  } else {
    initFilterViewMore();
  }

  // Re-initialize after AJAX filter updates
  document.addEventListener('collection:filter-update', initFilterViewMore);
  
  // Also listen for any partial page updates (common in Shopify themes)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-filter-view-more]')) {
            initFilterViewMore();
          }
        });
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
